/* eslint-disable @typescript-eslint/no-floating-promises */
import { initializeScript } from 'shared/initializers/initializeScript';

initializeScript();
